import { Link, useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";

import React, { useState, useEffect, useRef } from "react";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../redux/apiSlice";
import { toastify, userlogout } from '../redux/controller';
import 'react-toastify/dist/ReactToastify.css';
import Deleteicon from "../assets/trash.png";
import Editicon from "../assets/pencil.png";
import Xicon from "../assets/Delete Icon.svg"
import EditIcon from "../assets/pencil.png"

export default function Hunters() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedSeason = useSelector((state) => state.season.selectedSeason);

  const [perpage, setPerPage] = useState(10);

  const [managehunterstatus, setManagehunterstatus] = useState(false);
  const [editHunter, setEditHunter] = useState(false);
  const [totalHunters, setTotalHunter] = useState(0);
  const [selectedproperty, setSelectedproperty] = useState('');
  const [selectedHunterIdToEdit, setSelectedHunterForEdit] = useState('');
  const [membertype, setmembertype] = useState('');
  const [status, setStatus] = useState('Loading...');
  const [Reservationsdata, setReservationsdata] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const usertoken = localStorage.getItem('usertoken');

  const [currentPage, setCurrentPage] = useState(1);
  // Users count
  const [membershipusers, setmembershipusers] = useState([]);
  const [membershipuserscount, setmembershipuserscount] = useState(0);
  const [totalhunters, settotalhunters] = useState([]);

  const [loadingDetails, setLoadingDetails] = useState(true);

  const [showFirstNameError, setShowFirstNameError] = useState(false);
  const [showLastNameError, setShowLastNameError] = useState(false);
  const [showEmailError, setShowEmailError] = useState(false);
  const [showPhoneError, setShowPhoneError] = useState(false);
  const [showLoadingOnEditHunter, setShowLoadingOnEditHunter] = useState(false);

  const [emailError, setEmailError] = useState('');


  function handleEditPasswordClose() {
    setEditHunter(!editHunter);
  }

  const hunterFirstNameRef = useRef(null);
  const hunterLastNameRef = useRef(null);
  const hunterEmailRef = useRef(null);
  const hunterPhoneRef = useRef(null);

  const [stepinputField, setstepInputField] = useState({
    hunterId: "",
    hunterFirstName: "",
    hunterLastName: "",
    hunterEmail: "",
    hunterPhoneNumber: ""
  })

  const inputsHandler = (e) => {
    setstepInputField((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value
    }));
  };


  function handlepopupclose() {
    setManagehunterstatus(!managehunterstatus);
  }
  async function handlepopupclosedelete() {

    console.log(selectedproperty)
    var response = await dispatch(fetchData({
      "apiurl": "/auth/user/deletehunter",
      hunterid: selectedproperty,
      headers: { "x-access-token": usertoken }
    }))
    console.log(response)
    if (response && response.payload && response.payload.status == 200) {
      setManagehunterstatus(!managehunterstatus);
      toastify({ message: response.payload.message })
      getAllHunters("", 1)
    } else if (response && response.payload && response.payload.status == 400) {
      setManagehunterstatus(!managehunterstatus);
      toastify({ message: response.payload.message })
    }
    else {
      setManagehunterstatus(!managehunterstatus);
      toastify({ message: "Not able to delete hunter" })
    }
  }

  function changemembertype(e) {
    setmembertype(e.target.value)
    setCurrentPage(1);
  }

  const inputperPage = (event) => {
    setPerPage(event.target.value);
    setReservationsdata([]);
    setStatus('Loading...');
    setCurrentPage(1);
  };

  const getAllHunters = async (searchQuery = "", page = 1) => {

    setReservationsdata([]);
    setStatus('Loading...');
    var hunterlist = await dispatch(
      fetchData({
        apiurl: "/auth/user/allhunters",
        page: page,
        limit: perpage,
        search: searchQuery,
        membertype: membertype,
        headers: { "x-access-token": usertoken }
      })
    );

    if (hunterlist && hunterlist.payload && hunterlist.payload.status === 200) {

      setReservationsdata([]);
      if (hunterlist.payload.totalHunters === 0) {
        setStatus('No Hunter!');
        setCurrentPage(1)
        setTotalHunter(0)
      } else {
        const huntersListLocal = hunterlist.payload.hunters.map((hunters) => ({
          id: hunters.user._id,
          firstname: hunters.user.firstname,
          lastname: hunters.user.lastname,
          hunter_name: hunters.user.firstname + ' ' + hunters.user.lastname,
          email: hunters.user.email ?? '--',
          phone_number: hunters.user.phonenumber != null ? hunters.user.phonenumber.length > 0 ? hunters.user.phonenumber : '--' : '--',
          number_of_reservations: hunters.reservations.length,
          subscriptions: hunters.user.subscriptions,
          action: hunters.user.creditCard != null ? (hunters.user.creditCard.cardNumber != null ? 'Completed' : 'Pending') : 'Pending',
          createdAt: hunters.user.createdAt ?? '--'
        }));
        setReservationsdata(huntersListLocal);
        setTotalHunter(hunterlist.payload.totalHunters);
        setStatus('');
      }
    } else if (hunterlist.payload.response && hunterlist.payload.response.data && hunterlist.payload.response.data.message) {
      if (hunterlist.payload.response.data.message === "Invalid token provided!" || hunterlist.payload.response.data.message === "No token provided!") {
        // toastify({ message: 'Session expired' });
        userlogout();
        navigate('/');
      }
    } else {
      setStatus('No Hunter!');
    }
  };



  useEffect(() => {
    getallhuntercount();
  }, [selectedSeason]);


  useEffect(() => {
    getAllHunters(searchInput, currentPage);
  }, [currentPage, membertype, perpage]);

  async function getallhuntercount() {

    if (selectedSeason && selectedSeason.seasonEndDate && selectedSeason.seasonStartDate) {
      setLoadingDetails(true)
      var huntercount = await dispatch(
        fetchData({
          apiurl: "/auth/users/count",
          seasonEndDate: selectedSeason.seasonEndDate,
          seasonStartDate: selectedSeason.seasonStartDate,
          headers: { "x-access-token": usertoken }
        })
      );
      console.log(huntercount)
      setLoadingDetails(false)
      if (huntercount && huntercount.payload && huntercount.payload.status === 200) {
        setmembershipusers(huntercount.payload.membershipusers)
        setmembershipuserscount(huntercount.payload.membershipuserscount)
        settotalhunters(huntercount.payload.totalhunters)
      }
    }
  }

  function handleDeleteclick(index) {
    if (index.target.id && index.target.id.split("_")[1]) {
      setSelectedproperty(index.target.id.split("_")[1])
      setManagehunterstatus(true);
    }
  }


  async function handleChagepasswordsubmit() {
    if (stepinputField.hunterFirstName.length < 1) {
      setShowFirstNameError(true)
      return
    } else if (stepinputField.hunterLastName.length < 1) {
      setShowLastNameError(true)
      return
    } else if (stepinputField.hunterEmail.length < 1) {
      toastify({ 'message': "Please enter hunter email" })
      setShowEmailError(true)
      return
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(stepinputField.hunterEmail)) {
      toastify({ message: "Please enter a valid email address" });
      setShowEmailError(true)
      return;
    } else if (stepinputField.hunterPhoneNumber.length < 1) {
      toastify({ "message": "Please enter hunter phone number" });
      setShowPhoneError(true)
      return;
    } else if (!/^(\+1)?\s?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/.test(stepinputField.hunterPhoneNumber)) {
      toastify({ message: "Please enter a valid phone number" });
      setShowPhoneError(true)
      return;
    }

    setShowFirstNameError(false)
    setShowLastNameError(false)
    setShowEmailError(false)
    setShowPhoneError(false)

    setShowLoadingOnEditHunter(true)

    var body = {
      "apiurl": "/auth/user/edithunterdetails",
      "hunterid": stepinputField.hunterId,
      "firstname": stepinputField.hunterFirstName,
      "lastname": stepinputField.hunterLastName,
      "email": stepinputField.hunterEmail,
      "phone": stepinputField.hunterPhoneNumber,
      headers: { "x-access-token": usertoken }
    }
    var response = await dispatch(fetchData(body))

    setShowLoadingOnEditHunter(false)

    if (response && response.payload && response.payload.status === 200) {
      toastify({ message: 'Hunter details updated successfully' })
      setEditHunter(false)
      getAllHunters(searchInput, currentPage);
    }
    else if (response && response.payload && response.payload.response && response.payload.response.data && response.payload.response.data.status && response.payload.response.data.status == 500) {
      setEmailError(response.payload.response.data.message)
      setShowEmailError(true)
    } else {
      if (response.payload && response.payload.message) {
        toastify({ message: response.payload.message })
        if (response.payload.message === "Invalid token provided!") {
          userlogout()
          // Navigate('/')
        }
      }
    }
  }


  function handleEditclick(hunter) {
    setstepInputField({
      hunterId: hunter.id,
      hunterFirstName: hunter.firstname || "",
      hunterLastName: hunter.lastname || "",
      hunterEmail: hunter.email || "",
      hunterPhoneNumber: hunter.phone_number || ""
    });
    setEditHunter(true);
  }


  const handlePageClick = (selectedPage) => {
    console.log("Selected page ", selectedPage.selected + 1);
    setCurrentPage(selectedPage.selected + 1);
  };

  const handleSearch = () => {

    setReservationsdata([]);
    setStatus('Loading...');
    getAllHunters(searchInput, 1);
    setCurrentPage(1);
  };

  const handleAddHunter = () => {
    navigate("/newhunter")
  };

  const handleClearSearch = () => {
    setReservationsdata([]);
    setStatus('Loading...');
    setSearchInput("")
    getAllHunters("", 1)
    setCurrentPage(1)
    setTotalHunter(0)
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="hunter-main">

      <div className="dashboard-main">
        <div className="dashboard-section">
          <div className="dashboard-subsections" >
            <div className="dashboard-contant">
              <p className="title">Total Hunters</p>
              <h3>{loadingDetails ? <span className="loading-dots">.</span> : totalhunters.length}</h3>
            </div>
            <div className="dashboard-contant top_div">
              <div className="total-member-div"><p className="title">Total Members</p>

                <div class="tooltip-wrapper">
                  <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11V17C11.25 17.4142 11.5858 17.75 12 17.75Z" fill="#be7637"></path> <path d="M12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7Z" fill="#be7637"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75Z" fill="#be7637"></path> </g></svg>
                  <span class="tooltip-text">Total number of hunter who purchased memberships.</span>
                </div>

              </div>
              <h3>{loadingDetails ? <span className="loading-dots">.</span> : membershipusers.length}</h3>
            </div>
            <div className="dashboard-contant bottom">
              <div className="total-member-div"><p className="title">Memberships</p>
                <div class="tooltip-wrapper">
                  <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11V17C11.25 17.4142 11.5858 17.75 12 17.75Z" fill="#be7637"></path> <path d="M12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7Z" fill="#be7637"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75Z" fill="#be7637"></path> </g></svg>
                  <span class="tooltip-text">Total number of memberships buy in this season.</span>
                </div></div>
              <h3>{loadingDetails ? <span className="loading-dots">.</span> : membershipuserscount}</h3>
            </div>
          </div>
        </div>
      </div>

      <div className="search-div">
        <select className="membertype" onChange={changemembertype}>
          <option value={''}>ALL</option>
          <option value={'membership'}>Membership</option>
          <option value={'direct'}>Direct</option>
        </select>

        <div className="hunder_head_row_tabel">
          <div className="input-wrapper">
            <input
              type="text"
              className="form-control hunter-search"
              placeholder="Hunter Name, Email, Phone Number"
              onKeyDown={handleKeyDown}
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            {searchInput && (
              <button className="clear-btn" onClick={handleClearSearch}>×</button>
            )}
          </div>
          <button className="add-btn" onClick={handleSearch}>Search</button>
          <button className="add-btn-hunter" onClick={handleAddHunter}>+ Add Hunter</button>
        </div>
      </div>

      <div className="managecoupons-table add-form">
        <div className="add-table">
          <table className="table">
            <thead>
              <tr>
                {/* <th>Sr No.</th> */}
                <th>Hunter Name</th>
                <th>Email</th>
                <th>Phone Number</th>
                <th>Total Reservations</th>
                <th>Membership Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {Reservationsdata.length === 0 ?
                <td colSpan="5" style={{ textAlign: 'center' }}>
                  <div style={{
                    paddingLeft: '10px',
                    paddingTop: '40px',
                    display: 'inline-block',
                  }}>
                    {status}
                  </div>
                </td>
                :
                Reservationsdata.map((reservation, index) => (
                  <tr
                    key={reservation.id}
                    className={
                      reservation.action === "Pending"
                        ? "Action_cancelled"
                        : reservation.action === "Completed"
                          ? "Action_completed"
                          : ""
                    }
                  >
                    {/* <td>{index+1}</td> */}
                    <td>
                      <Link
                        className="hunter-link"
                        to={`/huntersdetails`}
                        state={reservation}
                        style={{
                          textDecoration: 'underline',
                          color: '#be7637'
                        }}
                      >{reservation.hunter_name}</Link></td>
                    <td>{reservation.email}</td>
                    <td>{reservation.phone_number}</td>
                    <td>
                      <Link
                        className="hunter-link"
                        to={`/huntersdetails`}
                        state={reservation}
                        style={{
                          textDecoration: 'underline',
                          color: '#be7637'
                        }}
                      >
                        {reservation.number_of_reservations}
                      </Link>
                    </td>
                    <td>
                      {reservation && reservation.subscriptions && reservation.subscriptions.length && reservation.subscriptions[reservation.subscriptions.length - 1].no_of_memberships ? "Membership" : "Direct"}
                      {/* <button
                        className="reservation-actionbtn"
                        onClick={() =>
                          reservation.action.toLowerCase() === "Cancelled"
                        }
                      >
                        <i class={
                          reservation.action === "Completed"
                            ? "fa-solid fa-circle-check"
                            : "fa-regular fa-clock"
                        }></i>
                        {reservation.action}
                      </button> */}

                    </td>
                    <td>
                      <img
                        src={EditIcon}
                        alt="EditIcon"
                        id={"EditIcon_" + reservation.id}
                        onClick={() => handleEditclick(reservation)}
                        className="delete-icon"
                        style={{ marginRight: "10px" }}
                      />

                      <img
                        src={Deleteicon}
                        alt="Deleteicon"
                        id={"deletehunter_" + reservation.id}
                        onClick={handleDeleteclick}
                        className="delete-icon"
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        {managehunterstatus && (
          <div className="managecou-popup">
            <div className="managecou-content">
              <i className="fa-solid fa-xmark" onClick={handlepopupclose}></i>
              <div className="managecou-contentdiv">
                <img src={Xicon} alt="Xicon" />
                <h1>Are you Sure Want to Delete?</h1>
                <p>This will result in the deletion of all reservations associated with this Hunter.</p>
              </div>
              <div className="managecou-btn">
                <button className="btn1" onClick={handlepopupclose}>
                  Cancel
                </button>
                <button className="btn2" onClick={handlepopupclosedelete}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}

        {editHunter && (
          <div className="chagepassword-popup">
            <div className="chagepassword-content hunteredit">
              <i
                className="fa-solid fa-xmark"
                onClick={handleEditPasswordClose}
              ></i>

              <div className="chagepass-popupcontent hunter">
                <h1>Edit Hunter Details</h1>
                <div className="form-row">
                  <h6>Hunter First name</h6>
                  <div className="input-group">
                    <div className="email-error">
                      <input
                        type="text"
                        id="hunter_first_name"
                        className="form-control"
                        placeholder="Hunter first name"
                        name="hunterFirstName"
                        onChange={inputsHandler}
                        value={stepinputField.hunterFirstName}
                        ref={hunterFirstNameRef}
                      />
                      {showFirstNameError && (
                        <div className="error-info">Please enter first name</div>
                      )}
                    </div>
                  </div>

                  <h6>Hunter Last name</h6>
                  <div className="input-group">
                    <div className="email-error">
                      <input
                        type="text"
                        id="hunter_last_name"
                        className="form-control"
                        placeholder="Hunter last name"
                        name="hunterLastName"
                        onChange={inputsHandler}
                        value={stepinputField.hunterLastName}
                        ref={hunterLastNameRef}
                      />{showLastNameError && (
                        <div className="error-info">Please enter last name</div>
                      )}
                    </div>
                  </div>


                  <h6>Hunter Email</h6>
                  <div className="input-group">
                    <div className="email-error">
                      <input
                        type="text"
                        id="hunter_email"
                        className="form-control"
                        placeholder="Hunter email"
                        name="hunterEmail"
                        onChange={inputsHandler}
                        value={stepinputField.hunterEmail}
                        ref={hunterEmailRef}
                      />
                      {showEmailError && (
                        <div className="error-info">{emailError}</div>
                      )}

                    </div>
                  </div>
                  <h6>Hunter Phone</h6>
                  <div className="input-group">
                    <div className="email-error">
                      <input
                        type="number"
                        id="hunter_phone"
                        className="form-control"
                        placeholder="Hunter phone"
                        name="hunterPhoneNumber"
                        onChange={inputsHandler}
                        value={stepinputField.hunterPhoneNumber}
                        ref={hunterPhoneRef}
                      />
                      {showPhoneError && (
                        <div className="error-info">Please enter phone</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="form-row w-100">
                  <button
                    type="submit"
                    className="users_btn change-passbtn"
                    onClick={handleChagepasswordsubmit}
                  >
                    {showLoadingOnEditHunter ? "Saving..." : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}



        <div className="rowperpage">
          <div className="perpagecount">
            Row Per Page
            <select
              onChange={inputperPage}
              value={perpage}>
              <option value={10}>10</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={150}>150</option>
              <option value={200}>200</option>
            </select>
          </div>
          <ReactPaginate
            pageCount={Math.ceil(totalHunters / perpage)}
            pageRangeDisplayed={perpage}
            breakLabel={"..."}
            marginPagesDisplayed={2}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            activeClassName={"active"}
          />
        </div>
      </div>
    </div>
  );
}
